import { useQuery } from "@tanstack/react-query";
import { Citation } from "../helpers/Models";
import { getExcerpt } from "../api/cited-excerpt";
import { useAuth } from "@clerk/clerk-react";

export const useGetCitedExcerpt = ({ citation }: { citation: Citation }) => {
  const { getToken } = useAuth();

  const {
    data: citedExcerpt,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["cited-excerpt", citation.text],
    queryFn: () => getExcerpt({ getToken, citation }),
  });

  return { citedExcerpt, isLoading, refetch };
};
